export type ResumenMetricValidation = 'default' | 'warning' | 'danger';

interface Props {
  value: number | null | undefined;
  validation?: ResumenMetricValidation;
}

const VALIDATION_CLASS: Record<ResumenMetricValidation, string> = {
  default: 'text-dark',
  warning: 'text-warning',
  danger: 'text-danger',
};

export const ResumenMetricCell = ({ value, validation = 'default' }: Props) => {
  const displayValue = value != null && value !== 0 ? value.toFixed(2) : '\u00a0';

  return (
    <div className="d-flex align-items-center justify-content-center tabular-nums" style={{ minHeight: '2rem' }}>
      <span className={`py-2 ${VALIDATION_CLASS[validation]}`} style={{ fontSize: '0.9rem' }}>
        {displayValue}
      </span>
    </div>
  );
};
